// extracted by mini-css-extract-plugin
export default {"body":"blog_body__o3ggN","btn":"blog_btn__n5bMc","top":"blog_top__y6lzD","inputBox":"blog_inputBox__uwCFl","filterBox":"blog_filterBox__YPzCP"};